import { useState, useEffect } from "react";
import * as firebase from "firebase/app";

const useFirebaseStorage = path => {
  const fileRef = firebase.storage().ref(path);
  const storageRef = firebase
    .storage()
    .ref("users/SesMIH8XZFY0dxQ6C4UQvCz9u752");
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUrl = () => {
    setLoading(true);
    fileRef
      .getDownloadURL()
      .then(url => {
        setUrl(url);
        setLoading(false);
        setError(false);
      })
      .catch(err => {
        setUrl(null);
        setLoading(false);
        setError(err);
      });
  };

  // get the initial URL
  useEffect(fetchUrl, []);

  const put = blob => {
    if (!blob || blob.size <= 0) return;
    setLoading(true);
    setUrl(null);
    fileRef.put(blob).then(snap => fetchUrl());
  };

  return { url, put, loading, error };
};

export default useFirebaseStorage;
